import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../Context';
import DashHeader from '../component/dashHeader/DashHeader';
import Sidebar from '../component/sidebar/Sidebar';
import Loader from '../pages/Loader/Loader';

const ProtectedRoute = ({ children }) => {

  const {user} = useContext(UserContext);


  // Check if the access_token is available in the cookies
  if (user === null) {
    return <div> <Loader/> </div>;
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render the protected page
  return (
    <div>
      <Sidebar />
      <DashHeader />
      {children}
    </div>
  );
};


export default ProtectedRoute;
